/**
 * Built-in theme registration. The single place where default, dark and macOS26
 * are wired up.
 */

import { registerTheme } from "./registry";
import type { ThemeConfig } from "./types";
import { createDefaultTheme } from "@/themes/default";
import { createDarkTheme } from "@/themes/dark";
import {
  macOS26ThemeConfig,
  macOS26DarkThemeConfig,
} from "@/themes/macOS26";
import { paperFinanceThemeConfig } from "@/themes/paperFinance";
import { npoFinanceThemeConfig } from "@/themes/npoFinance";
import { cleanEnterpriseThemeConfig } from "@/themes/cleanEnterprise";
import { operatorDarkThemeConfig } from "@/themes/operatorDark";

const builtin: ThemeConfig[] = [
  {
    id: "default",
    name: "Cool Blue",
    description: "Classic light glassmorphism theme",
    source: "builtin",
    createTheme: createDefaultTheme,
  },
  {
    id: "dark",
    name: "Dark",
    description: "Dark theme",
    source: "builtin",
    createTheme: createDarkTheme,
  },
  {
    ...macOS26ThemeConfig,
    source: "builtin" as const,
  },
  {
    ...macOS26DarkThemeConfig,
    source: "builtin" as const,
  },
  {
    ...paperFinanceThemeConfig,
    source: "builtin" as const,
  },
  {
    ...npoFinanceThemeConfig,
    source: "builtin" as const,
  },
  {
    ...cleanEnterpriseThemeConfig,
    source: "builtin" as const,
  },
  {
    ...operatorDarkThemeConfig,
    source: "builtin" as const,
  },
];

export function registerBuiltinThemes(): void {
  builtin.forEach(registerTheme);
}
